$(document).ready(() => {
    $('.product-tile-grid .slick-slider').slick({
        dots: true,
        swipe: false,
        arrows: true,
        // prevArrow: '<button type="button" class="slick-prev"><i class="far fa-chevron-left" aria-hidden="true"></i></button>',
        // nextArrow: '<button type="button" class="slick-next"><i class="far fa-chevron-right" aria-hidden="true"></i></button>',
        // slidesToShow: 1,
        // slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 2,
    })
})